import { initialState, StateType } from "./types";

type ZipCodeUpdate = typeof initialState.member.address;
export type ActionTypes =
  | { type: "GET_MEMBER"; payload: StateType }
  | { type: "GET_DROPDOWN"; payload: Pick<StateType, "dropdowns"> }
  | { type: "GET_MEMBER_AND_DROPDOWN"; payload: StateType }
  | { type: "ERROR"; error: { isError: boolean; message: string }; isLoading?: boolean }
  | { type: "UPDATE_MEMBER"; payload: string; field: string; error: { isError: boolean; message: string } }
  | { type: "LOADING"; isLoading: boolean }
  | { type: "UPDATE_ZIPCODE"; payload: ZipCodeUpdate; error: { isError: boolean; message: string } }
  | {
      type: "UPDATE_ZIPCODE_FIELDS";
      payload: string;
      error: { isError: boolean; message: string };
      field: string;
    };

export function reducer(_state: StateType, action: ActionTypes) {
  switch (action.type) {
    case "GET_MEMBER":
      return {
        ..._state,
        member: action.payload.member,
      };
    case "GET_DROPDOWN":
      return {
        ..._state,
        dropdowns: action.payload.dropdowns,
      };
    case "GET_MEMBER_AND_DROPDOWN":
      return {
        ..._state,
        member: action.payload.member,
        dropdowns: action.payload.dropdowns,
        zendesk: action.payload.zendesk,
      };
    case "UPDATE_MEMBER":
      return {
        ..._state,
        member: { ..._state.member, [action.field]: action.payload },
        error: { isError: action.error.isError, message: action.error.message },
      };
    case "UPDATE_ZIPCODE":
      return {
        ..._state,
        member: { ..._state.member, address: action.payload },
        error: { isError: action.error.isError, message: action.error.message },
      };
    case "UPDATE_ZIPCODE_FIELDS":
      return {
        ..._state,
        member: { ..._state.member, address: { ..._state.member.address, [action.field]: action.payload } },
        error: { isError: action.error.isError, message: action.error.message },
      };
    case "ERROR":
      return {
        ..._state,
        error: { isError: action.error.isError, message: action.error.message },
        isLoading: false,
      };
    case "LOADING":
      return {
        ..._state,
        isLoading: action.isLoading,
      };
    default:
      throw new Error();
  }
}
